<section class="mobile-filter-collapse tw:block tw:w-full"
  [class.mobile-filter-collapse--expanded]="contentVisible()">
  @if (toggleVisible()) {
    <button class="mobile-filter-collapse__toggle tw:w-full tw:rounded-app-pill tw:bg-app-white tw:text-app-text tw:text-app-sm tw:font-app-semibold tw:text-left"
      type="button"
      (click)="toggle()">
      {{ (contentVisible() ? hideLabelKey() : showLabelKey()) | translate }}
    </button>
  }

  @if (contentVisible()) {
    <div class="mobile-filter-collapse__content tw:w-full tw:min-w-0">
      <ng-content></ng-content>
    </div>
  }
</section>
